import * as React from 'react';

export const SolarExportMost = () => (
  <svg width="128" height="128" viewBox="0 0 128 128">
    <g fill="none">
      <path
        d="M128 64C128 99.3 99.3 128 64 128 28.6 128 0 99.3 0 64 0 28.6 28.6 0 64 0 99.3 0 128 28.6 128 64"
        fill="#F8F8F8"
      />
      <rect width="12" height="14" x="33" y="78" fill="#3F75C6" />
      <rect width="12" height="15.4" x="51" y="77" fill="#3F75C6" />
      <rect width="12" height="8.4" x="69" y="84" fill="#3F75C6" />
      <rect width="12" height="12.6" x="87" y="80" fill="#3F75C6" />
      <rect width="80" height="4" x="25" y="92" fill="#D2D2D2" />
      <rect
        width="63"
        height="4"
        x="-29.5"
        y="29.5"
        transform="translate(23 33)rotate(-90 2 31.5)"
        fill="#D2D2D2"
      />
    </g>
  </svg>
);
